function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useCallback, useMemo, useState } from 'react';
import { Wizard } from '@leverege/ui-wizard';
import { Dialog, Button } from '@leverege/ui-elements';
import { ModelFactory } from '@leverege/ui-plugin';
import { UseResponsiveBreakpoints } from '@leverege/molten/views';
import Path from '@leverege/path';
import S from './WizardModal.css';
import PairingWizardModel from "./PairingWizardModel.js";
const DEFAULT_VALUE = PairingWizardModel.create();
const EMPTY_OBJ = {};
export default function WizardModal(props) {
  const {
    AddAssetForm,
    AddTagForm,
    assetDelegate,
    attribute,
    clientProps,
    filters,
    onClose,
    parentAttribute,
    parentRelationship,
    relationship,
    show,
    tagDelegate,
    target
  } = props;
  const context = useMemo(() => {
    return {
      AddAssetForm,
      AddTagForm,
      assetDelegate,
      attribute,
      clientProps,
      filters,
      onClose,
      parentAttribute,
      parentRelationship,
      relationship,
      tagDelegate,
      target
    };
  }, [AddAssetForm, AddTagForm, assetDelegate, attribute, clientProps, filters, onClose, parentAttribute, parentRelationship, relationship, tagDelegate, target]);
  const model = useMemo(() => {
    const {
      attribute
    } = relationship;
    const overrides = attribute.metadata?.pairing?.wizard?.overrides;
    if (attribute.metadata?.pairing?.wizard?.model) {
      const Model = ModelFactory.get(attribute.metadata.pairing.wizard.model);
      if (Model) {
        return Model.create(overrides);
      }
    }
    if (overrides) {
      return PairingWizardModel.create(overrides);
    }
    return DEFAULT_VALUE;
  }, [relationship]);
  const [wizardData, setWizardData] = useState(EMPTY_OBJ);
  const onChange = useCallback(({
    data: stepName,
    value: stepData
  }) => {
    if (typeof stepName === 'string') {
      const data = {
        ...wizardData
      };
      Path.set(stepName, data, stepData);
      setWizardData(data);
    }
    if (typeof stepName === 'object') {
      const data = {
        ...wizardData
      };
      Object.entries(stepName).forEach(([key, val]) => {
        Path.set(key, data, stepData[val]);
      });
      setWizardData(data);
    }
  }, [wizardData]);
  const onReset = useCallback(() => {
    setWizardData(EMPTY_OBJ);
  }, []);
  return /*#__PURE__*/React.createElement(PairingResponsiveContainer, {
    model: model,
    value: wizardData,
    onChange: onChange,
    onReset: onReset,
    context: context,
    show: show,
    onClose: onClose
  });
}
const components = {
  small: PairingMobile,
  big: PairingDesktop
};
function PairingResponsiveContainer(props) {
  const {
    onClose
  } = props;
  const titleBarExtra = /*#__PURE__*/React.createElement(Button, {
    variant: "pairClose",
    onClick: onClose
  });
  return UseResponsiveBreakpoints(components, {
    ...props,
    titleBarExtra
  });
}
function PairingDesktop({
  show,
  onClose,
  ...rest
}) {
  return /*#__PURE__*/React.createElement(Dialog, {
    variant: "pairing",
    show: show,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Wizard, _extends({}, rest, {
    className: S.wizard,
    variant: "pairContent"
  })));
}
function PairingMobile({
  show,
  onClose,
  ...rest
}) {
  return /*#__PURE__*/React.createElement(Dialog, {
    position: "full",
    variant: "pairing",
    show: show,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Wizard, _extends({}, rest, {
    mobile: true,
    onClose: onClose,
    className: S.wizard,
    variant: "pairContent"
  })));
}